export * from './AWSCloudWatchProvider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aws-amplify/core/lib-esm/Providers/index.js
// module id = 1646
// module chunks = 0